import { render, staticRenderFns } from "./ConsentOnechatIndex.vue?vue&type=template&id=16bc0ccd&scoped=true&"
import script from "./ConsentOnechatIndex.vue?vue&type=script&lang=js&"
export * from "./ConsentOnechatIndex.vue?vue&type=script&lang=js&"
import style0 from "./ConsentOnechatIndex.vue?vue&type=style&index=0&id=16bc0ccd&prod&lang=css&"
import style1 from "./ConsentOnechatIndex.vue?vue&type=style&index=1&id=16bc0ccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc0ccd",
  null
  
)

export default component.exports